import { formatUnitValue } from "../../lib/convert";
import { AngleUnits } from "convert-units";
import { LabeledValue } from "../base/LabeledValue";

type CoordinateProps = {
  value: [number, number, number]; // RPY
  showLabels?: boolean;
  precision?: number;
  units?: AngleUnits;
};

const OrientationDisplay = ({
  value,
  showLabels = true,
  units = "deg",
  precision = 1,
}: CoordinateProps) => {
  let [roll, pitch, heading] = value ?? [];
  return (
    <div className="flex items-center space-x-4">
      <LabeledValue
        label={showLabels && "Roll"}
        value={formatUnitValue(roll, { from: "deg", to: units, precision })}
      />
      <LabeledValue
        label={showLabels && "Pitch"}
        value={formatUnitValue(pitch, { from: "deg", to: units, precision })}
      />
      <LabeledValue
        label={showLabels && "Yaw"}
        value={formatUnitValue(heading, { from: "deg", to: units, precision })}
      />
    </div>
  );
};

export default OrientationDisplay;
